import { cn } from "@/lib/utils";

/**
 * The kourai logo: a yellow tab on an ink page, "just a new tab" (DESIGN.md → Logo). Drawn on the
 * same grid as src/public/logo.svg, cropped to the art. The page takes the text color, so it
 * follows dark mode.
 */
function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="2 4 28 24"
      shapeRendering="crispEdges"
      className={cn("h-3 w-3.5 shrink-0", className)}
    >
      <rect x="2" y="4" width="14" height="6" className="fill-highlight" />
      <rect x="2" y="10" width="28" height="18" className="fill-current" />
    </svg>
  );
}

/** The kourai wordmark: the logo and the lowercase name, after geilo.co's small print. */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 text-[15px] font-medium tracking-[-0.02em] whitespace-nowrap",
        className,
      )}
    >
      <LogoMark />
      kourai
    </span>
  );
}
